import BaseSetup from '@/components/BaseSetup';
import { i18n } from '@/i18n';

export type SharedToggleEmits = {
	(e: 'update:modelValue', val: SharedToggleItemModel): void
};
export type SharedToggleProps = {
	modelValue?: SharedToggleItemModel
	options?: SharedToggleItemModel[]
};

export default class SharedToggleSetup extends BaseSetup {

	static readonly defaultProps = {
		modelValue: () => ({
			label: i18n.global.t('common.undefined'),
			counter: undefined,
		}),
		options: () => [{ 'label': 'premier' }, { 'label': 'second' }],
	};

	get options () { return this.props.options }

	get modelValue () { return this.props.modelValue }
	set modelValue (val: SharedToggleItemModel | undefined) {
		this.emits('update:modelValue', val ?? {
			label: this.$t('common.notProvided'),
			counter: undefined,
		});
	}

	constructor (
		private props: SharedToggleProps,
		private emits: SharedToggleEmits,
	) {
		super();
	}

}
